<template>
  <div id="root" :class="`${theme}-theme ${locale} ${layout}`" @dragstart="handleTouch" @touchstart="handleTouch">
    <component :is="layoutComponent">
      <router-view />
    </component>
    <div id="modal-container">
      <BaseFullScreenModal v-if="modalStore.fullScreenModalState.isOpen" />
      <BaseSyncModal />
      <BaseLoading v-show="commonStore.activeLoading" />
      <BaseDialog v-if="commonStore.isDialogShow" />
      <WaitingCountdownDialog v-if="commonStore.isWaitingPopupOpen" />

      <!-- 장바구니 모달 -->
      <Cart v-if="modalStore.isCartModalOpen" />

      <!-- 관리자 인증 모달 -->
      <ConfigAuthModal v-if="modalStore.isAdminAuthModalOpen" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import * as Android from '@/api/android';
  import BaseDialog from '@/components/base/BaseDialog.vue';
  import BaseLoading from '@/components/base/BaseLoading.vue';
  import EmptyLayout from '@/components/layouts/EmptyLayout.vue';
  import LeftNavCartLayout from '@/components/layouts/LeftNavCartLayout.vue';
  import LeftNavLayout from '@/components/layouts/LeftNavLayout.vue';
  import TopNavLayout from '@/components/layouts/TopNavLayout.vue';
  import WaitingCountdownDialog from '@/components/WaitingCountdownDialog.vue';
  import { useCommonStore } from '@/stores/common';
  import { useConfigStore } from '@/stores/config';
  import { useDeviceStore } from '@/stores/device';
  import { computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useLogger } from 'vue-logger-plugin';
  import { useRoute } from 'vue-router';
  import BaseFullScreenModal from './components/base/BaseFullScreenModal.vue';
  import BaseSyncModal from './components/base/BaseSyncModal.vue';
  import Cart from './components/Cart.vue';
  import ConfigAuthModal from './components/ConfigAuthModal.vue';
  import { useModalStore } from './stores/modal';
  import { preloadImages } from './utils/preloadImages';

  const { locale } = useI18n();
  const route = useRoute();
  const logger = useLogger();
  const commonStore = useCommonStore();
  const modalStore = useModalStore();
  const configStore = useConfigStore();
  const deviceStore = useDeviceStore();

  const theme = computed(() => {
    return configStore.config.Theme || 'light';
  });

  const layoutComponent = computed(() => {
    if (route.meta.layout === 'Main') {
      if (configStore.isMobileLayout) return TopNavLayout;
      switch (configStore.config.Template) {
        case 'left-nav':
          return LeftNavLayout;
        case 'left-nav-cart':
          return LeftNavCartLayout;
        default:
          return TopNavLayout;
      }
    }

    return EmptyLayout;
  });

  const layout = computed(() => {
    if (configStore.isMobileLayout) return 'top-nav';
    switch (configStore.config.Template) {
      case 'left-nav':
      case 'left-nav-cart':
        return 'left-nav';
      default:
        return 'top-nav';
    }
  });

  onMounted(async () => {
    logger.info('[APP] Mounted');

    // 이미지 프리로드
    await preloadImages();

    // 안드로이드 버전 조회
    configStore.setAndroidVersion(Android.getVersion());

    // 디바이스 상태 조회 초기화
    deviceStore.init();
  });

  const handleTouch = () => {
    // 대기 팝업 타임아웃이 설정되어 있는 경우에만 타임아웃 재설정
    if (commonStore.waitingPopupIntervalId) {
      commonStore.setWaitingPopupInterval();
    }
  };
</script>
